import React, { useState, useEffect, useRef, forwardRef } from "react";
import { IconButton, Switch, FormControlLabel } from "@mui/material";
import Moveable from "react-moveable";
import { Refresh } from "@mui/icons-material";
import { flushSync } from "react-dom";
import "../../../screens/SuperScreen/SuperScreen.css";
const MoveableWindow = forwardRef((props, ref) => {
  const { children, boundingRect, isEditEnabled, isSwitchOn, windowSize } =
    props;
  const twentyPercentW = windowSize?.width ? windowSize?.width * 0.2 : 0;
  const twentyPercentH = windowSize?.height ? windowSize?.height * 0.2 : 0;
  const savedStyle = boundingRect
    ? {
        width: boundingRect.width,
        height: boundingRect.height,
        left: boundingRect.left,
        top: boundingRect.top,
      }
    : {
        width: windowSize?.width ? windowSize?.width - twentyPercentW : 1280,
        height: windowSize?.height ? windowSize?.height - twentyPercentW : 720,
        left: twentyPercentW / 2,
        top: twentyPercentH / 2,
      };

  const [updatedStyle, setUpdatedStyle] = useState(savedStyle);
  const [border, setBorder] = useState("none");
  const [dragMode, setDragMode] = useState(true);

  const handleChangeDragMode = () => {
    setDragMode(!dragMode);
  };
  const [random, setRandom] = useState(0);
  const reloadClicked = () => {
    setRandom(random + 1);
  };

  let movableRef = useRef(null);

  const [mouseClicked, setMouseClicked] = useState(false);

  useEffect(() => {
    let timeoutId;
    if (border !== "none") {
      timeoutId = setTimeout(() => {
        setBorder("none");
      }, 3000);
    } else {
      clearTimeout(timeoutId);
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [border]);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current.contains(e.target)) {
        setMouseClicked(true);
      } else {
        setMouseClicked(false);
      }
    };
    document.body.style.backgroundColor = "transparent";
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  const getStyle = () => {
    let width = "100%";
    let height = "100%";

    let top = boundingRect?.top || updatedStyle.top || 0;
    let left = boundingRect?.left || updatedStyle.left || 0;
    if (boundingRect?.width) {
      width = boundingRect.width;
    } else if (updatedStyle.width) {
      width = updatedStyle.width;
    }
    if (boundingRect?.height) {
      height = boundingRect.height;
    } else if (updatedStyle.height) {
      height = updatedStyle.height;
    }

    if (boundingRect?.left) {
      left = boundingRect.left;
    } else if (updatedStyle.left) {
      left = updatedStyle.left;
    }

    if (boundingRect?.top) {
      top = boundingRect.top;
    } else if (updatedStyle.top) {
      top = updatedStyle.top;
    }

    return {
      width,
      height,
      top,
      left,
      border: mouseClicked ? "none" : border,
      zIndex: isSwitchOn ? 10 : "auto",
      position: "absolute",
    };
  };

  return (
    <>
      <div
        ref={ref}
        id="fixed-super-screen-window"
        style={getStyle()}
        className="rect-target superscreeninstance"
      >
        <div
          className="ssDragText"
          style={{ opacity: border !== "none" ? 1 : 0 }}
        >
          <div className="ssDragTextInner">
            <div>
              <FormControlLabel
                sx={{ ml: 1, color: "white", fontSize: "10px" }}
                control={
                  <Switch
                    checked={dragMode}
                    onChange={handleChangeDragMode}
                    title={
                      dragMode
                        ? "Toggle to Change Settings"
                        : "Toggle to Drag Screen"
                    }
                    inputProps={{
                      "aria-label": "controlled",
                    }}
                  />
                }
              />
              <IconButton
                onClick={reloadClicked}
                style={{ cursor: "pointer" }}
                size="large"
                title="Reload Screen Content"
              >
                <Refresh sx={{ color: "white" }} />
              </IconButton>
            </div>
          </div>
        </div>
        {dragMode ? <div className="handle ssDraggingStyle" /> : ""}
        {children}
        <div
          className="dragText"
          style={{ opacity: border !== "none" ? 1 : 0 }}
        >
          <div
            className="ssDragTextInner"
            style={{ color: "rgba(200, 200, 200, 0.8)" }}
          >
            click here to resize
          </div>
        </div>
      </div>

      <Moveable
        ref={movableRef}
        target={ref}
        origin={false}
        originDraggable={false}
        draggable={isEditEnabled}
        onDrag={(e) => {
          e.target.style.transform = e.transform;
          setUpdatedStyle({
            width: updatedStyle.width,
            height: updatedStyle.height,
            transform: e.transform,
          });
        }}
        resizable={isEditEnabled}
        onResize={(e) => {
          e.target.style.width = `${e.width}px`;
          e.target.style.height = `${e.height}px`;
          e.target.style.transform = e.drag.transform;
          setUpdatedStyle({
            width: e.width,
            height: e.height,
            transform: updatedStyle.transform,
          });
        }}
        rotatable={isEditEnabled && mouseClicked}
        onRotate={(e) => {
          e.target.style.transform = e.drag.transform;
          setUpdatedStyle({
            width: updatedStyle.width,
            height: updatedStyle.height,
            transform: e.drag.transform,
          });
        }}
        hideDefaultLines={!mouseClicked}
        renderDirections={mouseClicked ? undefined : []}
        flushSync={flushSync}
      />
    </>
  );
});

export default MoveableWindow;
